import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DemoregistrationComponent } from '../components/demoregistration/demoregistration.component';
import { LoginserviceService } from '../services/services/loginservice.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  userBO:any={};
  userrolerightsColl:any=[];
  userView: any = {};
  
  loginusername :string="";
  logoimgpath:string="";
  companyname: string = "";
  
  constructor(public router: Router, private loginService: LoginserviceService, private productFindService: NgbModal,) { 
    this.fnServiceChanges();
  }

  
  fnServiceChanges(){    
    this.userrolerightsColl = this.loginService.userrolerightsColl; 
    this.loginService.serviceloginChange.subscribe((value) => {
        this.userView = value                 
        if(this.userView.userBO){                
          this.userBO = this.userView.userBO      
          this.loginusername = this.userBO.username
          this.logoimgpath = this.userBO.logoimgpath
          this.companyname= this.userBO.companyname
        }      
        
    }); 
  }

  ngOnInit() {
    if(sessionStorage.hrtoken === undefined){
      this.router.navigate(['/Login']);
    }
    else{
      this.loginService.fnGetUserRoleList();
    }


  }


  fnLogout(){
    sessionStorage.removeItem("hrtoken");    
    this.router.navigate(['/Login']);
  }




  fnAddDemoRegister() {

    const modalRef = this.productFindService.open(DemoregistrationComponent, { size: <any>'l' });
    
    
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

     

    });
  }

}
